import { render, staticRenderFns } from "./GreenOperationAssessment.vue?vue&type=template&id=5872cb74&scoped=true&"
import script from "./GreenOperationAssessment.vue?vue&type=script&lang=js&"
export * from "./GreenOperationAssessment.vue?vue&type=script&lang=js&"
import style0 from "./GreenOperationAssessment.vue?vue&type=style&index=0&id=5872cb74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5872cb74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5872cb74')) {
      api.createRecord('5872cb74', component.options)
    } else {
      api.reload('5872cb74', component.options)
    }
    module.hot.accept("./GreenOperationAssessment.vue?vue&type=template&id=5872cb74&scoped=true&", function () {
      api.rerender('5872cb74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/GreenOperationAssessment.vue"
export default component.exports